import React, { useEffect } from 'react';
import TextInput from '@magento/venia-ui/lib/components/TextInput';
import { isRequired } from '@magento/venia-ui/lib/util/formValidators';
import Trigger from '@magento/venia-ui/lib/components/Trigger';
import { useFieldState, useFormApi, useFormState } from 'informed';
import { Field } from '../../../../components';
import classes from './claimItemInformation.module.css';
import CustomSelect from '../../../../components/CustomSelect';

var ClaimItem = function ClaimItem(_ref) {
  var index = _ref.index,
      field = _ref.field,
      remove = _ref.remove,
      orderDetails = _ref.orderDetails,
      handleItemChange = _ref.handleItemChange,
      setShowAddItem = _ref.setShowAddItem;

  var _useFieldState = useFieldState("".concat(field, ".item_name")),
      value = _useFieldState.value;

  var _useFormApi = useFormApi(),
      setValue = _useFormApi.setValue;

  var options = [{
    label: 'Size not as expected',
    value: 'Size not as expected'
  }, {
    label: 'Finish not as expected',
    value: 'Finish not as expected'
  }, {
    label: 'Damaged on Arrival',
    value: 'Damaged on Arrival'
  }];
  var lineItems = orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.line_details.map(function (line) {
    return {
      label: line.product_name_1,
      value: line.product_name_2
    };
  });

  var handleInitialData = function handleInitialData(value) {
    return orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.line_details.find(function (item) {
      return item.product_name_1 === value;
    });
  };

  useEffect(function () {
    if (value) {
      var initialData = handleInitialData((value === null || value === void 0 ? void 0 : value.label) || value);
      setValue("".concat(field, ".claimquantity"), initialData === null || initialData === void 0 ? void 0 : initialData.qty);
      setValue("".concat(field, ".item_number"), initialData === null || initialData === void 0 ? void 0 : initialData.product_name_2);
      setValue("".concat(field, ".reference_number"), (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.reference_number) !== '0' ? orderDetails.reference_number : 'N/A');
    }
  }, [value, setValue]);
  return React.createElement("div", {
    className: classes.inputs
  }, React.createElement(Field, {
    id: "item_name",
    label: "item_name"
  }, React.createElement(CustomSelect, {
    id: "item_name",
    validate: isRequired,
    field: "".concat(field, ".item_name"),
    placeholder: "Select product to Return *",
    options: lineItems,
    onChange: handleItemChange,
    key: "".concat(index, " + '-item_name'")
  })), React.createElement(Field, {
    id: "quantity",
    label: "quantity"
  }, React.createElement(TextInput, {
    field: "".concat(field, ".claimquantity"),
    id: "quantity",
    placeholder: "Claim Quantity",
    key: "".concat(index, " + '-quantity'"),
    type: "number"
  })), React.createElement(Field, {
    id: "item_number",
    label: "item_number"
  }, React.createElement(TextInput, {
    validate: isRequired,
    id: "item_number",
    field: "".concat(field, ".item_number"),
    placeholder: "Item Number",
    disabled: true,
    key: "".concat(index, " + '-item_number'")
  })), React.createElement(Field, {
    id: "reference_number",
    label: "reference_number"
  }, React.createElement(TextInput, {
    validate: isRequired,
    id: "reference_number",
    disabled: true,
    field: "".concat(field, ".reference_number"),
    placeholder: "PO Number",
    key: "".concat(index, " + '-reference_number'")
  })), React.createElement(Field, {
    id: "reason-to-return",
    label: "Reason to Return"
  }, React.createElement(CustomSelect, {
    placeholder: "Reason to Return *",
    required: true,
    field: "".concat(field, ".reason_to_return"),
    id: "reason-to-return",
    options: options
  })), index !== 0 && React.createElement("div", {
    className: "flex justify-end"
  }, React.createElement(Trigger, {
    classes: {
      root: 'underline font-bold text-bronze'
    },
    "aria-label": "Remove",
    action: function action() {
      remove();
      setShowAddItem(index);
    }
  }, "REMOVE")));
};

export default ClaimItem;